import {RootState} from '../store';

export const getAuthState = (state: RootState) => state.auth;
export const selectLoading = (state: RootState) => state.auth.isLoading;
export const isLoggedIn = (state: RootState) => state.auth.isLoggedIn;
export const selectLoggedInUser = (state: RootState) => state.auth.user;
